export class Author {
    public readonly name: string;
    public readonly id: number;
    public readonly affiliation_id: number
}



// WEBPACK FOOTER //
// ./src/models/CoAuthor.ts